import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Link} from 'react-router-dom'
import {Form, Errors, Control} from 'react-redux-form'
import {Row, Col, Checkbox} from 'react-bootstrap'
import LayoutContainer from "../../layout/layout-container/index";
import ErrorMessages from '../../login/error-messages'
import UserTitleSelector from '../../common/form/user/user-title-selector'
import UserFirstNameInput from '../../common/form/user/user-first-name-input'
import UserLastNameInput from '../../common/form/user/user-last-name-input'
import DateOfBirthSelector from '../../common/form/user/date-of-birth-selector'
import ArrowButton from '../../common/button-arrow'
import Can, {checkPermission} from "../../common/guards/can";
import RequiredInput from '../../common/form/elements/required-input';

class UserDetailsForm extends Component {

  constructor(props) {
    super(props);
  }

  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };

  render() {
    return (
      <LayoutContainer>
        <Form model="deep.personal_rewards"
              className="user-details-form"
              onSubmit={this.props.onSubmit}>
          <Errors className="errors" model="deep.personal_rewards" component={ErrorMessages}/>
          <Row>
            <Col lg={6}>
              <UserTitleSelector/>

              <UserFirstNameInput/>

              <UserLastNameInput/>

              <DateOfBirthSelector/>

              <RequiredInput model=".email"
                             placeholder="email"
                             label="Email address"/>

              <RequiredInput model=".mobile"
                             placeholder="mobile"
                             label="Mobile number"/>
            </Col>

            <Col lg={6}>
              <RequiredInput model=".store_name"
                             placeholder="Store name"
                             controlId="store_name"
                             label="Store name"/>
              <RequiredInput model=".address_1"
                             placeholder="Address line 1"
                             label="Address line 1"
                             controlId="personal_address_1"/>

              <RequiredInput model=".address_2"
                             placeholder="Address line 2"
                             label="Address line 2"
                             controlId="personal_address_2"/>

              <RequiredInput model=".town"
                             placeholder="Town"
                             label="Town"
                             controlId="personal_address_3"/>

              <RequiredInput model=".county"
                             placeholder="County"
                             label="County"
                             controlId="personal_address_4"/>

              <RequiredInput model=".eircode"
                             placeholder="Eircode"
                             label="Eircode"
                             controlId="eircode"/>
              <Control.checkbox model=".accept_terms" component={Checkbox}>
                I agree to the prepaid card <Link to="/content-pages/ppc-terms-conditions" target="_blank">terms and conditions</Link>.
              </Control.checkbox>
              <Errors
                show={{
                  touched: true,
                  focus: false
                }}
                className="errors"
                model='.accept_terms'/>

            </Col>

          </Row>
          <Row>
            <Col lg={12}>
              <ArrowButton color="red"
                           className="pull-right"
                           disabled={!this.props.formValid || !this.props.acceptedTerms}
                           arrow={false}>Opt in</ArrowButton>
            </Col>
          </Row>
        </Form>
      </LayoutContainer>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    formValid: state.deep.forms.personal_rewards.$form.valid,
    acceptedTerms: state.deep.personal_rewards.accept_terms,
  };
};

export default connect(mapStateToProps)(UserDetailsForm);


// WEBPACK FOOTER //
// ./src/components/home/personal-rewards/ppc-user-form.jsx